export default __webpack_public_path__ + "static/media/man-relaxed.0d70903e.svg";